import React from 'react'
import PropTypes from 'prop-types'
import { injectIntl, FormattedMessage } from 'react-intl'
import {
  Container,
  Button,
  Text,
  InstagramHandle
} from './CampaignStyledComponents'

// let name = socialMedia
const CampaignBanner = React.memo(
  ({ campaignData, name, instagram, storeId }) => {
    const showCampaign = campaignData.code === 'CIRQL'
    const UserName = instagram ? (
      <InstagramHandle href={instagram.url} target='_blank'>
        {instagram.name}
      </InstagramHandle>
    ) : (
      <InstagramHandle>{name}</InstagramHandle>
    )

    return showCampaign ? (
      <Container>
        <Text>
          {UserName} <FormattedMessage id='general.campaignInvite' />
        </Text>
        <Button
          size='sm'
          href={`https://thecirqle.hausmart.com/getstarted?utm_source=${storeId}`}
        >
          <FormattedMessage id='general.getStarted' />!
        </Button>
      </Container>
    ) : null
  }
)

CampaignBanner.displayName = 'CampaignBanner'

CampaignBanner.propTypes = {
  name: PropTypes.string.isRequired,
  campaignData: PropTypes.object.isRequired,
  instagram: PropTypes.object,
  storeId: PropTypes.string.isRequired
}

export default injectIntl(CampaignBanner)
